export default __webpack_public_path__ + "static/media/ico_view.fc19cb7a.svg";